import axios from 'axios';

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_HIM_ADMIN_DASHBOARD_URL as string,
});

export { axiosClient };
